/**
 * What is in this sandbox but not yet in production — asked of our own
 * server (server/build.ts), which asks production. Never the browser calling
 * production directly: that would need production to allow another origin,
 * and the answer would depend on the reviewer's network rather than the app's.
 */
import { useQuery } from '@tanstack/react-query'
import { type WaitingResponse, waitingResponseSchema } from '@/core/system/build'
import { statusQuery } from '@/lib/live-data'

async function fetchWaiting(): Promise<WaitingResponse> {
  const response = await fetch('/api/build/waiting', {
    credentials: 'include',
    headers: { accept: 'application/json' },
  })
  if (!response.ok) throw new Error(`Couldn't check what's waiting (${response.status}).`)
  return waitingResponseSchema.parse(await response.json())
}

export function useWaitingChanges(enabled: boolean) {
  // A status view (docs/LIVE-DATA.md). The server caches production's answer
  // for a minute; asking more often than that only repeats it.
  return useQuery(
    statusQuery(
      {
        queryKey: ['build', 'waiting'],
        queryFn: fetchWaiting,
        enabled,
        retry: false,
      },
      60_000,
    ),
  )
}
